import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const containerStyle = css`
  display: flex;
  align-items: center;
  position: relative;
  margin-right: ${theme.spacing(1)};
  overflow: hidden;
  gap: ${theme.spacing(1)};

  .unread-dot {
    top: 2px;
  }
`;

export const nameStyle = css`
  display: inline-flex;
  flex: 1;
  overflow: hidden;

  > span {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
